import { render, staticRenderFns } from "./ScrollWrapper.vue?vue&type=template&id=f3ab11f0&"
import script from "./ScrollWrapper.vue?vue&type=script&lang=js&"
export * from "./ScrollWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ScrollWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports